module.exports = __webpack_public_path__ + "img/Dantam Fashion 10.d1c2cfe2.jpg";